import React from "react";
import { ICONS } from "../../assets/Icons";

const SuccessModal = ({ show, handleClose, successMessage }) => {
  const handleBack = () => {
    handleClose();
  };

  return (
    // <div
    //   className={`modal-lg modal fade ${show ? "show" : ""}`}
    //   tabIndex="-1"
    //   role="dialog"
    //   style={{ display: show ? "block" : "none" }}
    // >
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(107, 114, 128, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1031,
      }}
    >
      <div className="modal-dialog" role="document">
        <div
          className="modal-content"
          style={{
            width: "416px",
            borderRadius: "24px",
            paddingLeft: "53px",
            paddingRight: "53px",
            paddingTop: "36px",
            paddingBottom: "36px",
            backgroundColor: "#FFF",
            border: "1px solid rgba(0, 0, 0, 0.175)",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={ICONS.SuccessIcon}
              alt="uploadCsv"
              style={{ width: "77px" }}
            />
            <p
              style={{ color: "#495057", fontSize: "32px", fontWeight: "500" }}
            >
              Success
            </p>
            <p
              style={{
                color: "#495057",
                fontSize: "16px",
                fontWeight: "500",
                whiteSpace: "nowrap",
              }}
            >
              {successMessage
                ? successMessage
                : "The request has been updated successfully"}
            </p>
            <button
              className="btn btn-submit"
              style={{ width: "150px", height: "52px" }}
              onClick={handleBack}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
